module.exports = __webpack_public_path__ + "img/thumbnail_BorneanPygmyElephant_m_normal.4409174b.png";